import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconEdgeAll12 from './IconEdgeAll12';
import IconEdgeAll16 from './IconEdgeAll16';
import IconEdgeAll20 from './IconEdgeAll20';
import IconEdgeAll24 from './IconEdgeAll24';
import IconEdgeAll32 from './IconEdgeAll32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconEdgeAll = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconEdgeAll12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconEdgeAll16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconEdgeAll20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconEdgeAll24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconEdgeAll32 {...props} />}
        </span>
    );
};
IconEdgeAll.displayName = 'FondueIconEdgeAll';

export default memo(IconEdgeAll);
